module.exports = __webpack_public_path__ + "static/media/3655E8_1_0.75779c67.woff";